import { useEffect, useRef } from 'react';
import type { VenueEventName } from '@/lib/shared-types';
import { getSocket } from '@/lib/realtime';

/**
 * Subscribe to one domain event for as long as the component is mounted.
 * `rooms` are joined on mount and the handler is always the latest render's.
 */
export function useRealtime<T = unknown>(
  event: VenueEventName,
  handler: (payload: T) => void,
  rooms: string[] = [],
) {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  const roomKey = rooms.join('|');

  useEffect(() => {
    const socket = getSocket(roomKey ? roomKey.split('|') : []);
    const listener = (payload: T) => handlerRef.current(payload);
    socket.on(event, listener);
    return () => {
      socket.off(event, listener);
    };
  }, [event, roomKey]);
}
